import React from 'react';
import { VerbalConsentScript } from '@unite-us/app-components';

const VerbalConsentScriptPage = () => (
  <VerbalConsentScript showBaseCard />
);

export default VerbalConsentScriptPage;
